/**
 * Przechowywanie {roomId, reconnectionToken} w sessionStorage (§6.1 / §6.4).
 * Przeżywa reload karty; nie wycieka między profilami (sessionStorage).
 */

export const PARK_SESSION_KEY = 'pieskowo.park.session';

export type ParkSessionRecord = {
  roomId: string;
  reconnectionToken: string;
  /** playerId — weryfikacja przy reload (inny profil → ignore). */
  playerId?: string;
};

export type SessionStorageLike = {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
};

function defaultStorage(): SessionStorageLike | null {
  try {
    if (typeof sessionStorage !== 'undefined') return sessionStorage;
  } catch {
    /* private mode */
  }
  return null;
}

export function loadParkSession(
  storage: SessionStorageLike | null = defaultStorage(),
): ParkSessionRecord | null {
  if (!storage) return null;
  try {
    const raw = storage.getItem(PARK_SESSION_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as Partial<ParkSessionRecord>;
    if (
      typeof v.roomId === 'string' &&
      v.roomId.length > 0 &&
      typeof v.reconnectionToken === 'string' &&
      v.reconnectionToken.length > 0
    ) {
      return {
        roomId: v.roomId,
        reconnectionToken: v.reconnectionToken,
        playerId: typeof v.playerId === 'string' ? v.playerId : undefined,
      };
    }
    return null;
  } catch {
    return null;
  }
}

export function saveParkSession(
  record: ParkSessionRecord,
  storage: SessionStorageLike | null = defaultStorage(),
): void {
  if (!storage) return;
  try {
    storage.setItem(PARK_SESSION_KEY, JSON.stringify(record));
  } catch {
    /* quota */
  }
}

export function clearParkSession(
  storage: SessionStorageLike | null = defaultStorage(),
): void {
  if (!storage) return;
  try {
    storage.removeItem(PARK_SESSION_KEY);
  } catch {
    /* ignore */
  }
}
